import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'lib-flexible'
//在main.js中需要全局引用一下样式，如下
import 'mint-ui/lib/style.css'
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
